var render, staticRenderFns
import script from "./StudipProxyCheckbox.vue?vue&type=script&lang=js&"
export * from "./StudipProxyCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/moritz/html/v4.6-hsfl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ff07d82')) {
      api.createRecord('6ff07d82', component.options)
    } else {
      api.reload('6ff07d82', component.options)
    }
    
  }
}
component.options.__file = "resources/vue/components/StudipProxyCheckbox.vue"
export default component.exports